import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enTranslations from "./locales/en.json";
import ptTranslations from "./locales/pt.json";
import deTranslations from "./locales/de.json";
import frTranslations from "./locales/fr.json";

const resources = {
  en: { translation: enTranslations },
  pt: { translation: ptTranslations },
  de: { translation: deTranslations },
  fr: { translation: frTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    debug: false,
    supportedLngs: ["en"],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: [],
      caches: [],
    },
  });

export default i18n;
